import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import { StaffMember } from "@/modules/staff/entity";
import Staff from "@/modules/staff/components/Staff.vue";
import QueryPaginator from "@/modules/vue/components/QueryPaginator.vue";
import StaffMemberLayout from "@/modules/staff/pages/StaffMemberLayout.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {
    const query = ref(StaffMember.createQueryBuilder('staff').leftJoin('staff.team', 'team').where('team.id is null'));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(StaffMemberLayout, null, {
        default: _withCtx(() => [_createVNode(QueryPaginator, {
          ref: "paginator",
          query: query.value,
          class: "mt-2"
        }, {
          default: _withCtx(({
            items
          }) => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, staffMember => {
            return _openBlock(), _createBlock(Staff, {
              key: staffMember.id,
              "staff-member": staffMember
            }, null, 8, ["staff-member"]);
          }), 128))]),
          _: 1
        }, 8, ["query"])]),
        _: 1
      });
    };
  }
});